import { useState, useEffect } from "react";
import { PublicClientApplication, Configuration } from "@azure/msal-browser";

const useMsalInstance = () => {
  const [msalInstance, setMsalInstance] =
    useState<PublicClientApplication | null>(null);
  const [isInitialized, setIsInitialized] = useState(false);
  const [hasRunOnce, setHasRunOnce] = useState(false);
  const [authority, setAuthority] = useState<string | null>(null);

  useEffect(() => {
    if (hasRunOnce) return;
    setHasRunOnce(true);
    const initializeMsal = async () => {
      try {
        const response = await fetch("/api/config");
        const config = await response.json();

        const msalConfig: Configuration = {
          auth: {
            clientId: config.clientId,
            authority: config.msalAuthority,
            redirectUri: config.redirectUri,
          },
          cache: {
            cacheLocation: "localStorage",
            storeAuthStateInCookie: true,
          },
          system: {
            // Increase timeout for iframe operations (default is 6 seconds)
            iframeHashTimeout: 10000, // 10 seconds
            // Enable additional logging for debugging
            loggerOptions: {
              loggerCallback: (
                level: any,
                message: string,
                containsPii: boolean
              ) => {
                if (!containsPii) {
                  switch (level) {
                    case 0: // Error
                      console.error("MSAL Error:", message);
                      break;
                    case 1: // Warning
                      console.warn("MSAL Warning:", message);
                      break;
                    case 2: // Info
                      console.info("MSAL Info:", message);
                      break;
                    case 3: // Verbose
                      console.debug("MSAL Debug:", message);
                      break;
                  }
                }
              },
              logLevel: 1, // Warning level and above
              piiLoggingEnabled: false,
            },
          },
        };

        const instance = new PublicClientApplication(msalConfig);
        await instance.initialize();

        setAuthority(`api://${config.clientId}/gaspoint.signin`);
        setMsalInstance(instance);
        setIsInitialized(true);
      } catch (error) {
        console.error("Failed to initialize MSAL instance:", error);
      }
    };

    initializeMsal();
  }, []);

  return { msalInstance, isInitialized, authority };
};

export default useMsalInstance;
